var StatusBadgeComponent = /** @class */ (function () {
    function StatusBadgeComponent() {
        this.text = 'Status';
        this.backgroundColor = '#FA0';
        this.textColor = '#000000';
    }
    return StatusBadgeComponent;
}());
export { StatusBadgeComponent };
